import React from "react";
import IntelligenceCostsPanel from "../components/intelligenceCostsPanel";

function IntelligenceCostsPage() {
  return <IntelligenceCostsPanel />;
}

IntelligenceCostsPage.propTypes = {};
IntelligenceCostsPage.defaultProps = {};

export default IntelligenceCostsPage;
